import { LEARN_MORE_MODAL_STATE } from '@/constants';
import { atomWithUniqueKey } from '@/utils';

export type LearnMoreModalState = {
  isOpen: boolean;
  current: number;
  totalOptions: number;
};

export const useLearnMoreModalState = atomWithUniqueKey<LearnMoreModalState>({
  key: LEARN_MORE_MODAL_STATE,
  default: { isOpen: false, current: 0, totalOptions: 3 },
});
